import { Alert, HFlow, Link, Text, VFlow } from 'bold-ui'
import { ReactComponent as Acompanhamento } from 'images/side-menu/acompanhamento-condicoes-saude.svg'
import { ReactComponent as LotesImunobiologico } from 'images/side-menu/cadastro-de-lote.svg'
import { ReactComponent as FichaVD } from 'images/side-menu/cds.svg'
import { ReactComponent as Cidadao } from 'images/side-menu/cidadao.svg'
import { ReactComponent as ConfiguracoesAD } from 'images/side-menu/configuracoes-ad.svg'
import { ReactComponent as ListaAtendimento } from 'images/side-menu/lista-de-atendimento.svg'
import { ReactComponent as UnificacaoCadastro } from 'images/side-menu/merge-do-cidadao.svg'
import { ReactComponent as TransmissaoDados } from 'images/side-menu/transmissao-de-dados.svg'
import React from 'react'

import acessarRNDS from '../../images/novidades/acessar_rnds.gif'
import cidadaoModulo from '../../images/novidades/cidadao.png'
import configRNDS from '../../images/novidades/configura_rnds.gif'
import fvd from '../../images/novidades/fvd.gif'
import gifAcompanhamento from '../../images/novidades/gif_acompanhamento.gif'
import gifListaAtendimento from '../../images/novidades/lista-atendimento.gif'
import gifUnificacao from '../../images/novidades/unificacao-cadastros.gif'
import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalPanelV4_10() {
  if (!process.env.REACT_APP_VERSION) {
    return (
      <Alert type='danger' inline>
        Nenhuma informação sobre versões anteriores está disponível.
      </Alert>
    )
  }

  return (
    <VFlow>
      <VFlow vSpacing={1}>
        <Text fontWeight='bold'>Módulos com novidades:</Text>
        <HFlow hSpacing={5}>
          <VFlow vSpacing={0.2}>
            <Text component='li'>Acompanhamento de condições de saúde </Text>
            <Text component='li'>Cidadão</Text>
            <Text component='li'>Configurações da atenção domiciliar</Text>
            <Text component='li'>Ficha de visita domiciliar</Text>
            <Text component='li'>Lotes de imunobiológico </Text>
          </VFlow>
          <VFlow vSpacing={0.2}>
            <Text component='li'>Lista de atendimentos </Text>
            <Text component='li'>Pesquisa de satisfação</Text>
            <Text component='li'>Rede Nacional de Dados em Saúde (RNDS)</Text>
            <Text component='li'>Transmissão de dados de atendimento </Text>
            <Text component='li'>Unificação de cadastros </Text>
          </VFlow>
        </HFlow>

        <NewsHeadingSection
          title='Acompanhamento de condições de saúde'
          icon={<Acompanhamento style={{ marginRight: '0.25rem', width: '32px', height: '32px' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              Este módulo permite que o profissional obtenha informações sobre cidadãos que possuem uma determinada
              condição de saúde, faixa de idade, sexo e/ou outros filtros disponíveis. Essas informações podem ser ser
              visualizadas de duas formas:
              <Text component='li'>
                Lista de cidadãos: apresenta os dados necessários para o profissional entrar em contato com o cidadão,
                como por exemplo telefone e endereço.
              </Text>
              <Text component='li'>
                Relatórios operacionais: é possível utilizar os filtros de busca do acompanhamento de condições de
                saúde, como por exemplo, faixa etária e sexo para gerar relatórios operacionais.
              </Text>
            </Text>
            <img src={gifAcompanhamento} style={{ width: '100%' }} alt='Gif Acompanhamento de condições de saúde' />
          </VFlow>
        </NewsHeadingSection>

        <NewsHeadingSection title='Cidadão' icon={<Cidadao style={{ marginRight: '0.25rem' }} />}>
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              O módulo do cidadão foi redesenhado. Ele possui as mesmas funcionalidades das versões anteriores, mas está
              mais fácil de usar. As principais alterações são:
            </Text>
            <Text component='li'>
              A busca pelo cadastro do cidadão está mais simples, todas as informações disponíveis para pesquisa estão
              na tela inicial do módulo e é possível pesquisar pelo nome, CNS ou CPF no mesmo campo.
            </Text>
            <Text component='li'>
              Foram feitas melhorias na comunicação com o CADSUS, reduzindo o tempo de resposta das pesquisas.
            </Text>
            <Text component='li'>
              Ao excluir um nome social ou telefone no cadastro do PEC, ele também será excluído no CADSUS.
            </Text>
            <img src={cidadaoModulo} style={{ width: '100%' }} alt='Imagem da tela de pesquisa por cidadão.' />
          </VFlow>
        </NewsHeadingSection>
        <NewsHeadingSection
          title='Configurações da atenção domiciliar'
          icon={<ConfiguracoesAD style={{ marginRight: '0.25rem' }} />}
        >
          <Text component='p'>
            As configurações de AD estão com um novo visual, mas as funcionalidades permanecem as mesmas.
          </Text>
        </NewsHeadingSection>

        <NewsHeadingSection title='Ficha de visita domiciliar' icon={<FichaVD style={{ marginRight: '0.25rem' }} />}>
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              Nesta versão foram incluídos campos para registrar informações de Sinais Vitais e Glicemia na Ficha de
              Visita Domiciliar.
            </Text>
            <img src={fvd} style={{ width: '100%' }} alt='Imagem de trecho da tela de Ficha de Visita Domiciliar.' />
          </VFlow>
        </NewsHeadingSection>

        <NewsHeadingSection
          title='Lotes de imunobiológico'
          icon={<LotesImunobiologico style={{ marginRight: '0.25rem' }} />}
        >
          <Text component='p'>
            O cadastro de lotes imunobiológico está com um novo visual, mas as funcionalidades permanecem as mesmas.
          </Text>
        </NewsHeadingSection>

        <NewsHeadingSection
          title='Lista de atendimentos'
          icon={<ListaAtendimento style={{ marginRight: '0.25rem' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>A lista de atendimentos está de cara nova:</Text>

            <Text component='li'>
              Os agendamentos do cidadão estão muito mais fáceis de serem visualizados e adicionados.
            </Text>
            <Text component='li'>
              Todas as funcionalidades, exceto as relacionadas a atendimento, encontram-se no menu "Mais opções".
            </Text>
            <img src={gifListaAtendimento} style={{ width: '100%' }} alt='Gif da lista de atendimentos' />
          </VFlow>
        </NewsHeadingSection>

        <NewsHeadingSection title='Pesquisa de satisfação do usuário'>
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              A pesquisa de satisfação do usuário tem como objetivo coletar a avaliação dos usuários sobre o sistema.
              Ela será apresentada para todos os profissionais 15 dias após o primeiro login.
            </Text>
          </VFlow>
        </NewsHeadingSection>

        <NewsHeadingSection title='Rede Nacional de Dados em Saúde'>
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              O PEC agora está integrado com a Rede Nacional de Dados em Saúde (RNDS). Esta integração permite que,
              durante um atendimento, os profissionais acessem dados de saúde do cidadão que forem registrados em outros
              estabelecimentos de saúde. Nesta versão nenhum dado registrado no PEC será enviado para a RNDS. Para
              utilizar a integração com a RNDS os administradores da instalação e municipal devem habilitá-la no PEC.
            </Text>
            <Text component='li'>
              O administrador da instalação cria a pasta "chaves", dentro da pasta de instalação do e-SUS APS e adiciona
              o certificado digital (.pfx) do município.
            </Text>
            <Text component='li'>
              O administrador municipal registra o certificado e habilita o uso da RNDS no módulo de Gestão municipal.
            </Text>
            <img
              src={configRNDS}
              style={{ width: '100%' }}
              alt='Gif apresentando como habilitar o uso da RNDS no PEC.'
            />
            <Text component='li'>
              Quando a RNDS está habilitada no PEC, a opção "Acessar RNDS" é apresentada na tela de atendimento. Ao
              selecionar essa opção, o profissional é direcionado para o site do ConecteSUS onde poderá visualizar todos
              os dados de saúde do cidadão.
            </Text>
            <img
              src={acessarRNDS}
              style={{ width: '100%' }}
              alt='Gif apresentando como acessar o RNDS a partir da tela de atendimento do PEC.'
            />
            <span>
              Você pode consultar mais informações sobre a RNDS no site{' '}
              <Link target='_blank' href='https://rnds.saude.gov.br/.'>
                https://rnds.saude.gov.br/.{' '}
              </Link>
            </span>
          </VFlow>
        </NewsHeadingSection>

        <NewsHeadingSection
          title='Transmissão de dados de atendimento'
          icon={<TransmissaoDados style={{ marginRight: '0.25rem' }} />}
        >
          <Text component='p'>
            A partir desta versão as informações sobre as prescrições de medicamentos e encaminhamentos registrados nos
            atendimentos também serão transmitidas junto com as demais informações do atendimento.
          </Text>
          <br />
          <Text>
            Foram incluídos os links de transmissão dos dados para a centralizadora estadual nos estados : Acre,
            Amazonas, Bahia, Ceará, Mato Grosso, Mato Grosso do Sul, Paraná , Pernambuco, Piauí, Rondônia e Santa
            Catarina.
          </Text>
        </NewsHeadingSection>

        <NewsHeadingSection
          title='Unificação de cadastros'
          icon={<UnificacaoCadastro style={{ marginRight: '0.25rem' }} />}
        >
          <VFlow vSpacing={0.5}>
            <Text component='p'>
              A unificação de cadastros está de cara nova. Unificar cadastros e prontuários será mais simples para os
              profissionais.
            </Text>
            <img src={gifUnificacao} style={{ width: '100%' }} alt='Fluxo do processo de unificação de cadastros' />
          </VFlow>
        </NewsHeadingSection>
      </VFlow>
    </VFlow>
  )
}
